/** Visible "*" for a required field; hidden from assistive tech, so required-ness must be conveyed by the input or its validation. */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-destructive">
      {' *'}
    </span>
  )
}
